// iOS/PWA app icon badge (notification-center-and-badge-plan.md §5.5/§6). Only does anything on an
// installed (home-screen, standalone) PWA -- inside a normal browser tab `setAppBadge` is absent, so
// this is a silent no-op there and the bell's in-UI count is the fallback affordance.
export function setAppBadgeCount(count: number): void {
  const nav = navigator as Navigator & {
    setAppBadge?: (count?: number) => Promise<void>;
    clearAppBadge?: () => Promise<void>;
  };
  if (!nav.setAppBadge || !nav.clearAppBadge) return;
  if (count > 0) {
    nav.setAppBadge(count).catch(() => undefined);
  } else {
    nav.clearAppBadge().catch(() => undefined);
  }
}
